import { type FC } from 'react'

import {
  ACTIONS,
  DESCRIPTIONS,
  ERROR_MESSAGES,
  MENU,
  SUCCESS_MESSAGES
} from '@/constants/common/message.constants'
import { createSiteImportJob } from '@/features/site-import-jobs/api'

import { isOpenSiteImportModalAtom } from '../../-states'
import { CsvImportModal } from '../CsvImportModal/CsvImportModal'

type Props = {
  tenantKey: string
}

/**
 * 地点マスタインポートModal
 */
export const SiteImportModal: FC<Props> = ({ tenantKey }) => {
  return (
    <CsvImportModal
      tenantKey={tenantKey}
      isOpenAtom={isOpenSiteImportModalAtom}
      modalTitle={MENU.IMPORTING_SITE_MASTER}
      draggerTitle={ACTIONS.UPLOAD_SITE}
      draggerDescription={<>{DESCRIPTIONS.UPLOAD_SITE_CSV}</>}
      createImportJob={(formValue, dcId) =>
        createSiteImportJob({ tenantKey, dto: { ...formValue, dcId } })
      }
      successMessage={SUCCESS_MESSAGES.STARTED_SITE_IMPORT}
      errorMessage={ERROR_MESSAGES.FAILED_TO_SITE_IMPORT}
      historyRoute="/$tenantKey/settings/site-import-jobs"
    />
  )
}
